import dayjs from 'dayjs';
import { IAddress } from 'app/shared/model/address.model';
import { IEan } from 'app/shared/model/ean.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { MeteringPeriod } from 'app/shared/model/enumerations/metering-period.model';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';

export interface IMeter {
  id?: number;
  balanceSupplierCompanyId?: string | null;
  balanceResponsibleCompanyId?: string | null;
  meteringResponsibleCompanyId?: string | null;
  technicalCommunicationSM?: string | null;
  allocationMethod?: string | null;
  contractedCapacity?: string | null;
  energyDeliveryStatus?: string | null;
  invoiceMonth?: string | null;
  maxConsumption?: string | null;
  physicalCapacity?: string | null;
  isSmartMeterTurnedOn?: boolean | null;
  standaardJaarAfname?: number | null;
  standaardJaarInvoeding?: number | null;
  isSpecialMeteringPoint?: boolean | null;
  isDoubleMeter?: boolean | null;
  transactionDossierNumber?: string | null;
  reference?: string | null;
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  productType?: keyof typeof ProductType | null;
  meteringPeriod?: keyof typeof MeteringPeriod | null;
  feedType?: keyof typeof FeedType | null;
  profileCategory?: string | null;
  capacityTariffCode?: string | null;
  physicalStatus?: string | null;
  usageSegment?: string | null;
  locationDescription?: string | null;
  meterNumber?: string | null;
  meterType?: string | null;
  administrativeStatus?: string | null;
  smartMeterReadability?: string | null;
  temperatureCorrection?: string | null;
  numberOfCounters?: number | null;
  counterIndication?: number | null;
  tariffZone?: string | null;
  meteringDirection?: string | null;
  countingWheels?: string | null;
  multiplicationFactor?: number | null;
  initialStartDate?: dayjs.Dayjs | null;
  meterAddress?: IAddress | null;
  ean?: IEan | null;
}

export const defaultValue: Readonly<IMeter> = {
  isSmartMeterTurnedOn: false,
  isSpecialMeteringPoint: false,
  isDoubleMeter: false,
};
